export default __webpack_public_path__ + "static/media/AR.4f8c68d0.svg";